import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SecurityService {

  constructor() { }

  get cryptojs() {
    return CryptoJS;
  }

  get key() {
    return CryptoJS.enc.Utf8.parse(environment.security.key).toString();
  }

  SHA256(data: string): string {
    return CryptoJS.SHA256(data).toString();
  }

  base64Encode(data: string): string {
    return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(data));
  }

  base64Decode(data: string): string {
    return CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
  }

  encrypt(data: string, key?: string): string {
    const securitySalt = CryptoJS.lib.WordArray.random(128 / 8);
    const sKey = (key !== undefined) ? CryptoJS.enc.Utf8.parse(key).toString() : this.key;
    const securityKey = CryptoJS.PBKDF2(sKey, securitySalt, {
      keySize: 256 / 32,
      iterations: 100
    });
    const securityIv = CryptoJS.lib.WordArray.random(128 / 8);
    const encryptedData = CryptoJS.AES.encrypt(data.toString(), securityKey, {
      iv: securityIv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC
    });
    return (securitySalt.toString() + encryptedData.toString() + securityIv.toString());
  }

  decrypt(data: string, key?: string): string {
    if (data === undefined || data === null) { return data; }
    const securitySalt = CryptoJS.enc.Hex.parse(data.substr(0, 32));
    const securityIv = CryptoJS.enc.Hex.parse(data.substr(-32));
    const sKey = (key !== undefined) ? CryptoJS.enc.Utf8.parse(key).toString() : this.key;
    const securityKey = CryptoJS.PBKDF2(sKey, securitySalt, {
      keySize: 256 / 32,
      iterations: 100
    });
    let encryptedData = data.substr(32);
    encryptedData = encryptedData.substr(0, encryptedData.length - 32);
    const decryptedData = CryptoJS.AES.decrypt(encryptedData, securityKey, {
      iv: securityIv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC
    });
    return decryptedData.toString(CryptoJS.enc.Utf8);
  }

  aesEncrypt(data: string, key?: string) {
    if (data === undefined || data === null || data === '') { return data; }
    const sKey = (key) ? key : environment.security.key;
    console.log(sKey);
    return CryptoJS.AES.encrypt(data, sKey, {
      format: {
        stringify: function (cipherParams) {
          const data: any = [];
          data.push(cipherParams.salt.toString());
          data.push(cipherParams.ciphertext.toString(CryptoJS.enc.Base64));
          data.push(cipherParams.iv.toString());
          const strData: any = data.join(':');
          return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(strData));
        },
        parse: function (encryptData) {
          const enData = CryptoJS.enc.Base64.parse(encryptData).toString(CryptoJS.enc.Utf8);
          const data = enData.split(':');
          const cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: CryptoJS.enc.Base64.parse(data[1]) });
          cipherParams.iv = CryptoJS.enc.Hex.parse(data[2])
          cipherParams.salt = CryptoJS.enc.Hex.parse(data[0])
          return cipherParams;
        }
      }
    }).toString();
  }

  aesDecrypt(data: string, key?: string) {
    if (data === undefined || data === null || data === '') { return data; }
    const sKey = (key) ? key : environment.security.key;
    return CryptoJS.AES.decrypt(data, sKey, {
      format: {
        stringify: function (cipherParams) {
          const data: any = [];
          data.push(cipherParams.salt.toString());
          data.push(cipherParams.ciphertext.toString(CryptoJS.enc.Base64));
          data.push(cipherParams.iv.toString());
          const strData: any = data.join(':');
          return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(strData));
        },
        parse: function (encryptData) {
          const enData = CryptoJS.enc.Base64.parse(encryptData).toString(CryptoJS.enc.Utf8);
          const data = enData.split(':');
          const cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: CryptoJS.enc.Base64.parse(data[1]) });
          cipherParams.iv = CryptoJS.enc.Hex.parse(data[2])
          cipherParams.salt = CryptoJS.enc.Hex.parse(data[0])
          return cipherParams;
        }
      }
    }).toString(CryptoJS.enc.Utf8);
  }

}
